import { SMART_GOALS_TEXT_LONG, SMART_GOALS_TEXT_SHORT } from '@/constants/stringVars';
import { HStack, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

const SmartFrameworkWithTooltip = ({ fontWeight = 700 }: { fontWeight?: number }) => {
  return (
    <HStack gap={'4px'}>
      <Text variant={'urbanistBold'} fontWeight={fontWeight} color={'text.mediumGray'}>
        Use the{' '}
      </Text>
      <Tooltip
        label={SMART_GOALS_TEXT_LONG}
        placement={'bottom'}
        color={'text.mediumBlue'}
        background={'white'}
        maxWidth={'380px'}
        left={12}
        borderRadius={'8px'}
        fontWeight={600}
        padding={'10px'}
      >
        <Text
          variant={'urbanistBold'}
          cursor={'default'}
          borderBottom={'dotted'}
          color={'text.mediumGray'}
          marginTop={'2px'}
          fontWeight={fontWeight}
        >
          {SMART_GOALS_TEXT_SHORT}
        </Text>
      </Tooltip>
      <Text variant={'urbanistBold'} fontWeight={fontWeight} color={'text.mediumGray'}>
        {' '}
        for setting goals.
      </Text>
    </HStack>
  );
};

export default SmartFrameworkWithTooltip;
